import initialState from '../store/initial-state';

// Dummy reducer to have the 'markers' entry on the store.
const markersReducer = (state = initialState.markers, action) => {  // eslint-disable-line no-unused-vars
  return state;
};

export default markersReducer;
